import { useEffect, useState } from 'react';

export const useGetWindowHref = () => {
  const [href, setHref] = useState(typeof window !== 'undefined' ? window.location.href : '');

  const listenToPopstate = () => {
    const winHref = window.location.href;
    setHref(winHref);
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', listenToPopstate);
      window.addEventListener('sharedHeader:historyChanged', listenToPopstate);

      return () => {
        window.removeEventListener('popstate', listenToPopstate);
        window.removeEventListener('sharedHeader:historyChanged', listenToPopstate);
      };
    }
  }, []);

  return href;
};
